import useProtoMethod from "./useProtoMethod";
import {
  ListAdvisorApplicationsRequest,
  ListAdvisorApplicationsResponse,
  GetAdvisorApplicationRequest,
  GetAdvisorApplicationResponse,
  UpdateAdvisorApplicationRequest,
  UpdateAdvisorApplicationResponse,
  SendAdvisorMeetingInvitationRequest,
  SendAdvisorMeetingInvitationResponse,
} from "../protogen/advisor_pipeline_service_pb";

const useListAdvisorApplications = (
  callback?: (r: ListAdvisorApplicationsResponse) => void,
) => {
  return useProtoMethod<
    ListAdvisorApplicationsRequest,
    ListAdvisorApplicationsResponse
  >("ListAdvisorApplications", ListAdvisorApplicationsResponse, { callback });
};

const useGetAdvisorApplication = (
  callback?: (r: GetAdvisorApplicationResponse) => void,
) => {
  return useProtoMethod<
    GetAdvisorApplicationRequest,
    GetAdvisorApplicationResponse
  >("GetAdvisorApplication", GetAdvisorApplicationResponse, { callback });
};

const useUpdateAdvisorApplication = (
  callback?: (r: UpdateAdvisorApplicationResponse) => void,
) => {
  return useProtoMethod<
    UpdateAdvisorApplicationRequest,
    UpdateAdvisorApplicationResponse
  >("UpdateAdvisorApplication", UpdateAdvisorApplicationResponse, { callback });
};

const useSendAdvisorMeetingInvitation = (
  callback?: (r: SendAdvisorMeetingInvitationResponse) => void,
) => {
  return useProtoMethod<
    SendAdvisorMeetingInvitationRequest,
    SendAdvisorMeetingInvitationResponse
  >("SendAdvisorMeetingInvitation", SendAdvisorMeetingInvitationResponse, {
    callback,
  });
};

export {
  useListAdvisorApplications,
  useGetAdvisorApplication,
  useUpdateAdvisorApplication,
  useSendAdvisorMeetingInvitation,
};
